import {CREDIT_CALC_ID} from '../../constants/common';

export default [
    {
        path: '^/business/free-accelerator',
        redirectTo: 'https://acc.centrinvest.ru/',
        code: 301,
    },
    {
        path: '^/social-projects/financial-literacy',
        redirectTo: 'https://xn----7sbbzgbvlb6b9j.xn--p1ai/',
        code: 301,
    },
    {
        path: '^/ru/gk-rostov-card',
        redirectTo: '/for-individuals/cards/debet-cards/gk-rostov-card',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/debet/exclusive',
        redirectTo: '/for-individuals/cards/debet-cards/exclusive',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/kreditnye-karty/univ',
        redirectTo: '/for-individuals/crediting/credit-cards?tab=1#cards-pickup',
        code: 301,
    },
    {
        path: '^/ru/biz/bankovskie-garantii',
        redirectTo: '/business/bank-guarantees',
        code: 301,
    },
    {
        path: '^/ru/biz/programmy-kreditovanija',
        redirectTo: '/business/business-crediting',
        code: 301,
    },
    {
        path: '^/ru/biz/kreditovanie-predprijatij-malogo-biznesa/programmy-kreditovanija',
        redirectTo: '/business/business-crediting',
        code: 301,
    },
    {
        path: '^/ru/biz/kreditovanie-predprijatij-malogo-biznesa/programmy-kreditovanija/start-up',
        redirectTo: '/business/business-crediting',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/rublevye-vklady/prolognacija',
        redirectTo: '/for-individuals/deposits/ruble-deposits?tab=2#ruble-deposits-info',
        code: 301,
    },
    {
        path: '^/ru/about/news/.{1,}',
        redirectTo: '/about/press-releases/',
        replacedPathPart: '/ru/about/news/',
        code: 301,
    },
    {
        path: '^/ru/about/smi/.{1,}',
        redirectTo: '/about/mass-media/',
        replacedPathPart: '/ru/about/smi/',
        code: 301,
    },
    {
        path: '^/ru/about/articles/.{1,}',
        redirectTo: '/about/books-articles/',
        replacedPathPart: '/ru/about/articles/',
        code: 301,
    },
    {
        path: '^/ru/investors/esg',
        redirectTo: '/esg',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/tarif/promo2',
        redirectTo: '/for-individuals/crediting/credit-cards?tab=2#cards-pickup',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/mirskidok',
        redirectTo: '/for-individuals/cards/debet-cards',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/ipoteka/{0,1}$',
        redirectTo: '/for-individuals/mortgage',
        code: 301,
    },
    {
        path: '^/ru/biz/finansovyj-lizing',
        redirectTo: '/business/leasing',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/fin-reports',
        redirectTo: '/about/investors/pub-info',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/inside-docs',
        redirectTo: '/about/investors/pub-info/inside-docs',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/debet/narod-mir',
        redirectTo: '/for-individuals/cards/debet-cards/narod-mir',
        code: 301,
    },
    {
        path: '^/ru/branches.{0,}',
        redirectTo: '/about/offices-and-atms',
        code: 301,
    },
    {
        path: '^/ru/fiz/cennye-bumagi/brokerskoe-obsluzhivanie',
        redirectTo: '/for-individuals/securities#securities-brokerage',
        code: 301,
    },
    {
        path: '^/ru/investors/info/shareholders',
        redirectTo: '/about/investors/shareholders',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/medical-professionals',
        redirectTo: '/social-projects/medical-professionals',
        code: 301,
    },
    {
        path: '^/ru/biz/korporativnye-karty',
        redirectTo: '/business/corporate-cards',
        code: 301,
    },
    {
        path: '^/ru/fiz/obsluzhivanie',
        redirectTo: '/for-individuals/vip-service',
        code: 301,
    },
    {
        path: '^/ru/corp/klient-bank/centr-invest_biznes_onlajn',
        redirectTo: '/business/client-bank',
        code: 301,
    },
    {
        path: '^/ru/biz/equiring',
        redirectTo: '/business/acquiring',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/kreditovanie/potrebitelskij-kredit',
        redirectTo: '/for-individuals/crediting/consumer-loan',
        code: 301,
    },
    {
        path: '^/ru/student-cards\\?univ=sfedu',
        redirectTo: '/for-individuals/cards/student-cards/sfedu',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-seifovye-yacheiki',
        redirectTo: '/for-individuals/safe-boxes',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/debet/univ',
        redirectTo: '/for-individuals/cards/debet-cards/univ',
        code: 301,
    },
    {
        path: '^/ru/vip/sberezhenija-i-investicii/vklady',
        redirectTo: '/for-individuals/deposits',
        code: 301,
    },
    {
        path: '^/ru/fiz/denezhnye-perevody/{0,1}(\\?.{0,})?$',
        redirectTo: '/for-individuals/money-transfers',
        code: 301,
    },
    {
        path: '^/ru/biz/zarplatnye-proekty',
        redirectTo: '/business/salary-projects',
        code: 301,
    },
    {
        path: '^/ru/about/articles/{0,1}$',
        redirectTo: '/about/books-articles',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/kreditnye-karty/discount-period',
        redirectTo: '/for-individuals/crediting/credit-cards#cards-pickup',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/avtokreditovanie',
        redirectTo: '/for-individuals/crediting/car-loans',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/dop-service/{0,1}(\\?.{0,})?$',
        redirectTo: '/for-individuals/cards/card-features',
        code: 301,
    },
    {
        path: '^/ru/fiz/cennye-bumagi',
        redirectTo: '/for-individuals/securities',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/tarif',
        redirectTo: '/for-individuals/crediting/service-tariffs',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/pokupka-refinance',
        redirectTo: '/for-individuals/refinancing/mortgage-refinancing',
        code: 301,
    },
    {
        path: '^/ru/investors/{0,1}$',
        redirectTo: '/about/investors',
        code: 301,
    },
    {
        path: '^/ru/about/smi/{0,1}$',
        redirectTo: '/about/mass-media',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/regulatory-purp',
        redirectTo: '/about/investors/regulatory-purp',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/debet/mir',
        redirectTo: '/for-individuals/cards/debet-cards/mir',
        code: 301,
    },
    {
        path: '^/ru/selfemployed/{0,1}(\\?.{0,})?$',
        redirectTo: '/business/self-employed',
        code: 301,
    },
    {
        path: '^/ru/{0,1}(\\?.{0,})?$',
        redirectTo: '/',
        code: 301,
    },
    {
        path: '^/ru/biz/razmeschenie-denezhnyh-sredstv-cennye-bumagi/deposit',
        redirectTo: '/business/placement-of-funds-and-securities',
        code: 301,
    },
    {
        path: '^/ru/corp/klient-bank/centr-invest_biznes_onlajn',
        redirectTo: '/business/client-bank',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/rublevye-vklady/snesnizhost',
        redirectTo: '/for-individuals/deposits/ruble-deposits/irreducible',
        code: 301,
    },
    {
        path: '^/ru/selfemployed/selfemployed-credit',
        redirectTo: '/business/self-employed',
        code: 301,
    },
    {
        path: '^/ru/biz/{0,1}(\\?.{0,})?$',
        redirectTo: '/business',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/refinance-programms',
        redirectTo: '/for-individuals/refinancing',
        code: 301,
    },
    {
        path: '^/ru/biz/rko/{0,1}(\\?.{0,})?$',
        redirectTo: '/business/opening-and-maintaining-account',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/commercial-property',
        redirectTo: '/for-individuals/mortgage/commercial-property',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/{0,1}(\\?.{0,})?$',
        redirectTo: '/for-individuals/crediting',
        code: 301,
    },
    {
        path: '^/ru/fiz/prodaja-monet',
        redirectTo: '/for-individuals/sale-of-coins',
        code: 301,
    },
    {
        path: '^/ru/about/info/recvizit',
        redirectTo: '/files/about/requisites.pdf',
        code: 301,
    },
    {
        path: '^/ru/about/{0,1}(\\?.{0,})?$',
        redirectTo: '/about',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/help',
        redirectTo: '/about/contacts?tab=1#feedback-faq',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/dop-service/mobile-banking',
        redirectTo: '/for-individuals/mobile-bank',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/standard-contracts',
        redirectTo: '/for-individuals/deposits/ruble-deposits/marketplace',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/dop-service/internet-bank',
        redirectTo: '/for-individuals/internet-bank-service',
        code: 301,
    },
    {
        path: '^/ru/about/board-of-directors',
        redirectTo: '/about/investors/struct-controls/board-of-directors',
        code: 301,
    },
    {
        path: '^/ru/nadzorniy_organ',
        redirectTo: '/nadzorniy_organ',
        code: 301,
    },
    {
        path: '^/ru/fiz/tarify-na-obsluzhivanie',
        redirectTo: '/for-individuals/service-rates',
        code: 301,
    },
    {
        path: '^/ru/fiz/denezhnye-perevody/zolotaya-korona',
        redirectTo: '/for-individuals/money-transfers/golden-crown',
        code: 301,
    },
    {
        path: '^/ru/strakhovaniye_vkladov',
        redirectTo: '/deposit-insurance',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/potrebitelskij-kredit/potrebitelskye-tseli',
        redirectTo: '/for-individuals/crediting/consumer-loan/credit-for-all',
        code: 301,
    },
    {
        path: '^/ru/about/career',
        redirectTo: '/social-projects/career',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/building',
        redirectTo: '/for-individuals/mortgage/building',
        code: 301,
    },
    {
        path: '^/ru/fiz/internet-bank',
        redirectTo: '/for-individuals/internet-bank-service',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/questions',
        redirectTo: '/about/contacts#feedback-faq',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/{0,1}$',
        redirectTo: '/for-individuals/cards/debet-cards',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/rublevye-vklady/pensionnye',
        redirectTo: '/for-individuals/deposits',
        code: 301,
    },
    {
        path: '^/ru/biz/rko/tarif',
        redirectTo: '/business/opening-and-maintaining-account#rko-tariffs',
        code: 301,
    },
    {
        path: '^/ru/obratnaja-svjaz',
        redirectTo: '/about/contacts#feedback-form',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/byyear',
        redirectTo: '/about/investors/pub-info',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/fininternational',
        redirectTo: '/about/investors/pub-info',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/rublevye-vklady/nakopitelnye',
        redirectTo: '/for-individuals/deposits',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/potrebitelskij-kredit/kredit-dlya-vseh',
        redirectTo: '/for-individuals/crediting/consumer-loan/credit-for-all',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/ipoteka-s-gospodderzhkoy',
        redirectTo: '/for-individuals/mortgage/new-building',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/kreditnye-karty',
        redirectTo: '/for-individuals/crediting/credit-cards',
        code: 301,
    },
    {
        path: '^/ru/about/info',
        redirectTo: '/about',
        code: 301,
    },
    {
        path: '^/en/{0,1}.{0,}',
        redirectTo: 'https://www.centrinvest.com',
        isEnglishVersion: true,
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/kursy-valyut',
        redirectTo: '/for-individuals/currency-rates',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/paket-dokumentov',
        redirectTo: '/for-individuals/crediting/paket-dokumentov',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/ipoteka-deti',
        redirectTo: '/for-individuals/mortgage/mortgage-children',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/{0,1}$',
        redirectTo: '/about/investors/pub-info',
        code: 301,
    },
    {
        path: '^/ru/investors/reports/presentations',
        redirectTo: '/about/investors/reports',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/ipoteka-secondary',
        redirectTo: '/for-individuals/refinancing/mortgage-refinancing',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/rublevye-vklady/termdeposits',
        redirectTo: '/for-individuals/deposits/ruble-deposits',
        code: 301,
    },
    {
        path: '^/ru/biz/klient-bank',
        redirectTo: '/business/client-bank',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/calc',
        redirectTo: `/for-individuals/crediting#${CREDIT_CALC_ID}`,
        code: 301,
    },
    {
        path: '^/ru/fiz/{0,1}(\\?.{0,})?$',
        redirectTo: '/',
        code: 301,
    },
    {
        path: '^/ru/about/news/{0,1}(\\?.{0,})?$',
        redirectTo: '/about/press-releases',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/potrebitelskij-kredit/{0,1}(\\?.{0,})?$',
        redirectTo: '/for-individuals/crediting/consumer-loan',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/{0,1}(\\?.{0,}){0,}$',
        redirectTo: '/for-individuals/deposits',
        code: 301,
    },
    {
        path: '^/for-individuals/mortgage/mortgage-excellent-student',
        redirectTo: '/for-individuals/mortgage',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/{0,1}(\\?.{0,})?$',
        redirectTo: '/for-individuals/mortgage',
        code: 301,
    },
    {
        path: '^/ru/biz/{0,1}(\\?.{0,})?$',
        redirectTo: '/business',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/materinskii-capital',
        redirectTo: '/for-individuals/mortgage/maternal-capital',
        code: 301,
    },
    {
        path: '^/ru/fiz/biometrics',
        redirectTo: '/for-individuals/biometric-data',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/{0,1}(\\?.{0,})?$',
        redirectTo: '/for-individuals/cards/debet-cards',
        code: 301,
    },
    {
        path: '^/ru/fiz/detskaya-karta',
        redirectTo: '/for-individuals/cards/debet-cards/mir-child',
        code: 301,
    },
    {
        path: '^/ru/student-cards',
        redirectTo: '/for-individuals/cards/student-cards',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/gk-rostov-card',
        redirectTo: '/for-individuals/cards/debet-cards/gk-rostov-card',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/selfemployed-card',
        redirectTo: '/for-individuals/cards/debet-cards/selfemployed-card',
        code: 301,
    },
    {
        path: '^/ru/biz/torgovoe-finansirovanie',
        redirectTo: '/business/trade-finance',
        code: 301,
    },
    {
        path: '^/ru/selfemployed-card',
        redirectTo: '/for-individuals/cards/debet-cards/selfemployed-card',
        code: 301,
    },
    {
        path: '^/ru/biz/razmeschenie-denezhnyh-sredstv-cennye-bumagi',
        redirectTo: '/business/placement-of-funds-and-securities',
        code: 301,
    },
    {
        path: '^/ru/biz/investicii-v-energosberezhenie',
        redirectTo: '/business/energy-saving-investment',
        code: 301,
    },
    {
        path: '^/ru/investors/reports',
        redirectTo: '/about/investors/reports',
        code: 301,
    },
    {
        path: '^/ru/investors/reports/strategy',
        redirectTo: '/about/investors/reports',
        code: 301,
    },
    {
        path: '^/ru/investors/reports/annual',
        redirectTo: '/about/investors/reports',
        code: 301,
    },
    {
        path: '^/ru/investors/info/shareholders',
        redirectTo: '/about/investors/shareholders',
        code: 301,
    },
    {
        path: '^/ru/investors/info/meetings-of-shareholders',
        redirectTo: '/about/investors/meetings-of-shareholders',
        code: 301,
    },
    {
        path: '^/ru/investors/info/registrar',
        redirectTo: '/about/investors/registrar',
        code: 301,
    },
    {
        path: '^/ru/investors/ratings-rankings',
        redirectTo: '/about',
        code: 301,
    },
    {
        path: '^/about/investors/international-activity',
        redirectTo: '/about',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/important-facts',
        redirectTo: 'https://e-disclosure.ru/portal/company.aspx?id=3018',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/inside-info',
        redirectTo: '/files/about/reports/insideInfo2024.pdf',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/aff-list',
        redirectTo: 'http://www.e-disclosure.ru/portal/files.aspx?id=3018&type=6',
        code: 301,
    },
    {
        path: '^/ru/investors/pub-info/interfax',
        redirectTo: 'https://e-disclosure.ru/portal/company.aspx?id=3018',
        code: 301,
    },
    {
        path: '^/ru/investors/corporate-governance/principles',
        redirectTo: '/about/investors/principles',
        code: 301,
    },
    {
        path: '^/ru/investors/corporate-governance/struct-controls',
        redirectTo: '/about/investors/structure',
        code: 301,
    },
    {
        path: '^/ru/investors/international-activity',
        redirectTo: '/about/investors/international-activity',
        code: 301,
    },
    {
        path: '^/ru/about/businesseducation',
        redirectTo: 'https://school.centrinvest.ru/',
        code: 301,
    },
    {
        path: '^/ru/about/events',
        redirectTo: '/about/events',
        code: 301,
    },
    {
        path: '^/b/.{1,}',
        redirectTo: '/about/offices-and-atms/office?id=',
        replacedPathPart: '/b/',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/deposit-operations$',
        redirectTo: 'https://centrinvest.ru/cabinet/remote-recording/unit',
        replacedPathPart: '/ru/fiz/vklady/deposit-operations',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/deposit-operations_internal$',
        redirectTo: 'https://centrinvest.ru/cabinet/remote-recording/unit',
        replacedPathPart: '/ru/fiz/vklady/deposit-operations_internal',
        code: 301,
    },
    {
        path: '^/ru/fiz/vklady/deposit-operations_kb$',
        redirectTo: 'https://centrinvest.ru/cabinet/remote-recording/unit',
        replacedPathPart: '/ru/fiz/vklady/deposit-operations_kb',
        code: 301,
    },
    {
        path: '^/ru/fiz/kreditovanie/oplata-kreditov',
        redirectTo: '/for-individuals/crediting/remote-payment-methods-for-loans',
        code: 301,
    },
    {
        path: '^/s/docs',
        redirectTo: '/for-individuals/tariffs-and-documents/cards-docs',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/advanced',
        redirectTo: '/for-individuals/cards/debet-cards/advanced',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/mir-supreme',
        redirectTo: '/for-individuals/cards/debet-cards/mir-supreme',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/mir-supreme-plus',
        redirectTo: '/for-individuals/cards/debet-cards/mir-supreme-plus',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/pens',
        redirectTo: '/for-individuals/cards/debet-cards/pens',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/premium',
        redirectTo: '/for-individuals/cards/debet-cards/premium',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/exclusive',
        redirectTo: '/for-individuals/cards/debet-cards/exclusive',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/servisnaia-karta-mir',
        redirectTo: '/for-individuals/cards/debet-cards/servisnaia-karta-mir',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/karta-bolelshchika-futbolnogo-kluba-chaika',
        redirectTo: '/for-individuals/cards/debet-cards/karta-bolelshchika-futbolnogo-kluba-chaika',
        code: 301,
    },
    {
        path: '/for-individuals/cards/debet-cards/karta-bolelshchika-futbolnogo-kluba-chaika',
        redirectTo: '/for-individuals/cards/debet-cards/advanced',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/dop-service/konserj',
        redirectTo: '/for-individuals/cards/concierge-service',
        code: 301,
    },
    {
        path: '^/ru/fiz/spravochnaya-informatsiya',
        redirectTo: '/for-individuals/reference-information',
        code: 301,
    },
    {
        path: '^/hr',
        redirectTo: '/social-projects/career',
        code: 301,
    },
    {
        path: '^/ru/biz/rko/valjutny-kontrol',
        redirectTo: '/business/opening-and-maintaining-account',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/docs',
        redirectTo: '/for-individuals/tariffs-and-documents/cards-docs',
        code: 302,
    },
    {
        path: '^/about/calendar',
        redirectTo: '/',
        code: 302,
    },
    {
        path: '^/ru/internetbank',
        redirectTo: '/for-individuals/internet-bank-service',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/ipoteka-village',
        redirectTo: '/for-individuals/mortgage/village',
        code: 302,
    },
    {
        path: '^/ru/corp/rko/{0,1}(\\?.{0,})?$',
        redirectTo: '/business/opening-and-maintaining-account',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/docs',
        redirectTo: '/for-individuals/tariffs-and-documents/cards-docs',
        code: 302,
    },
    {
        path: '^/ru/rss',
        redirectTo: '/rss',
        code: 302,
    },
    {
        path: '^/ru/internetbank',
        redirectTo: '/business/client-bank',
        code: 302,
    },
    {
        path: '^/ru/investors/pub-info/finrussia',
        redirectTo: '/about/investors/pub-info',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/internet-bank',
        redirectTo: '/for-individuals/internet-bank-service',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/re-release-card/step1',
        redirectTo: '/for-individuals/cards/rerelease-card',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/kreditnyye-kanikuly',
        redirectTo: '/for-individuals/crediting/repayment-credits',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/security',
        redirectTo: '/for-individuals/cards/security',
        code: 302,
    },
    {
        path: '^/ru/investors/contacts',
        redirectTo: '/about/investors#investor-contacts',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/potrebitelskij-kredit/kredit-goals',
        redirectTo: '/for-individuals/crediting/consumer-loan/potreb-goals',
        code: 302,
    },
    {
        path: '^/ru/corp/klient-bank',
        redirectTo: '/business/client-bank',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/dop-service/mir-pay',
        redirectTo: '/for-individuals/cards/card-features/mir-pay',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/potrebitelskij-kredit/kredit-dlya-samozanyatyh',
        redirectTo: '/for-individuals/crediting/self-employed',
        code: 302,
    },
    {
        path: '^/ru/corp/{0,1}(\\?.{0,})?$',
        redirectTo: '/business',
        code: 302,
    },
    {
        path: '^/ru/corp/kreditovanie',
        redirectTo: '/business/business-crediting',
        code: 302,
    },
    {
        path: '^/ru/vip/premium',
        redirectTo: '/for-individuals/vip-service',
        code: 302,
    },
    {
        path: '^/about/index.php',
        redirectTo: '/about',
        code: 302,
    },
    {
        path: '^/index.php',
        redirectTo: '/',
        code: 302,
    },
    {
        path: '^/ru/fiz/denezhnye-perevody/western-union',
        redirectTo: '/for-individuals/money-transfers',
        code: 302,
    },
    {
        path: '^/ru/biz/kredit-na-otkrytie-biznesa/startbusiness',
        redirectTo: '/business/business-crediting',
        code: 302,
    },
    {
        path: '^/ru/biz/kredit-na-otkrytie-biznesa',
        redirectTo: '/business/business-crediting',
        code: 302,
    },
    {
        path: '^/ru/corp/equiring',
        redirectTo: '/business/acquiring',
        code: 302,
    },
    {
        path: '^/ru/corp/klient-bank/info',
        redirectTo: '/business/client-bank',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/mat-cap',
        redirectTo: '/for-individuals/mortgage',
        code: 302,
    },
    {
        path: '^/ru/vip/prodaja-monet',
        redirectTo: '/for-individuals/sale-of-coins',
        code: 302,
    },
    {
        path: '^/ru/fiz/platezhi',
        redirectTo: '/',
        code: 302,
    },
    {
        path: '^/ru/biz/acquiring-test',
        redirectTo: '/business/acquiring',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/commercial-refinance',
        redirectTo: '/business/business-crediting/kommercheskaia-ipoteka',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/ipoteka/ipoteka-primary',
        redirectTo: '/for-individuals/mortgage/new-building',
        code: 302,
    },
    {
        path: '^/ru/fiz/vklady/rublevye-vklady',
        redirectTo: '/for-individuals/deposits/ruble-deposits',
        code: 302,
    },
    {
        path: '^/ru/corp/rko/tarif',
        redirectTo: '/business/opening-and-maintaining-account#rko-tariffs',
        code: 302,
    },
    {
        path: '^/ru/fiz/sovety-po-finansam',
        redirectTo: '/about/contacts#feedback-faq',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/dop-service/perevod-kart',
        redirectTo: '/for-individuals/cards/card-features',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/debet/premium',
        redirectTo: '/for-individuals/cards/debet-cards/premium',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/kreditovanie/kreditnye-karty',
        redirectTo: '/for-individuals/crediting/credit-cards',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/tarif/lgotny-period',
        redirectTo: '/for-individuals/crediting/credit-cards?tab=2#cards-pickup',
        code: 302,
    },
    {
        path: '^/ru/ipotekakmv',
        redirectTo: ' /for-individuals/mortgage',
        code: 302,
    },
    {
        path: '^/agreement.html',
        redirectTo: '/agreement',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/potrebitelskij-kredit/kredit-marketplace',
        redirectTo: '/for-individuals/crediting/consumer-loan/credit-marketplace',
        code: 302,
    },
    {
        path: '^/ru/corp/bankovskie-garantii',
        redirectTo: '/business/bank-guarantees',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/debet/pens',
        redirectTo: '/for-individuals/cards/debet-cards/pens',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/perevod-kart',
        redirectTo: '/for-individuals/cards/card-features',
        code: 302,
    },
    {
        path: '^/ru/mir-pay-promo',
        redirectTo: '/for-individuals/cards/card-features/mir-pay',
        code: 302,
    },
    {
        path: '^/ru/biz/razmeschenie-denezhnyh-sredstv/deposit/procent-ur',
        redirectTo: '/business/placement-of-funds-and-securities',
        code: 302,
    },
    {
        path: '^/ru/vip/bankovskie-seifovye-yacheiki',
        redirectTo: '/for-individuals/safe-boxes',
        code: 302,
    },
    {
        path: '^/ru/about/to-investors/presentations',
        redirectTo: '/about/investors/reports',
        code: 302,
    },
    {
        path: '^/ru/corp/rko/valjutny-kontrol',
        redirectTo: '/business/opening-and-maintaining-account?tab=2#rko-info',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/dop-service/internet-oparation',
        redirectTo: '/for-individuals/cards/card-features',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/dop-uslugi',
        redirectTo: '/for-individuals/crediting/credit-cards',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/kreditovanie',
        redirectTo: '/for-individuals/crediting',
        code: 302,
    },
    {
        path: '^/ru/fiz/kreditovanie/spacial',
        redirectTo: '/for-individuals/crediting',
        code: 302,
    },
    {
        path: '^/ru/sitemap',
        redirectTo: '/sitemap.xml',
        code: 302,
    },
    {
        path: '^/sitemap_new.xml',
        redirectTo: '/sitemap.xml',
        code: 302,
    },
    {
        path: '^/wifi/index.html',
        redirectTo: '/wifi',
        code: 302,
    },
    {
        path: '^/c01',
        redirectTo: '/for-individuals/cards/debet-cards',
        code: 302,
    },
    {
        path: '^/ru/about/reports',
        redirectTo: '/about/investors/pub-info',
        code: 302,
    },
    {
        path: '^/ru/about/investor/presentations',
        redirectTo: '/about/investors/reports',
        code: 302,
    },
    {
        path: '^/ru/about/mission',
        redirectTo: '/about/investors/reports',
        code: 302,
    },
    {
        path: '^/ru/about/management',
        redirectTo: '/about/investors/principles',
        code: 302,
    },
    {
        path: '^/ru/online-zayavki/kreditovanie-fizicheskih-lic',
        redirectTo: '/cabinet/new-creditform/start',
        code: 302,
    },
    {
        path: '^/ru/online-zayavki/req.loan.indiv.kabinet',
        redirectTo: '/cabinet',
        code: 302,
    },
    {
        path: '^/ru/online-zayavki/kfl-kabinet',
        redirectTo: '/cabinet/new-creditform/start',
        code: 302,
    },
    {
        path: '^/ru/fiz/sms-bank/info',
        redirectTo: '/',
        code: 302,
    },
    {
        path: '^/ru/investors/pub-info/info-cb',
        redirectTo: '/about/investors/pub-info',
        code: 302,
    },
    {
        path: '^/ru/online-zayavki/hr-quest',
        redirectTo: '/cabinet/training',
        code: 302,
    },
    {
        path: '^/ru/online-zayavki/cardreissue/card.reissue',
        redirectTo: '/cabinet/card',
        code: 302,
    },
    {
        path: '^/ru/online-zayavki/perevypusk-plastikovoj-karty',
        redirectTo: '/cabinet/card',
        code: 302,
    },
    {
        path: '^/publications/strategy',
        redirectTo: '/publications/Presentation2_Strategy_2019-2021_English.pdf',
        code: 302,
    },
    {
        path: '^/chk',
        redirectTo: '/cabinet/new-creditform/check',
        code: 302,
    },
    {
        path: '^/SDGs',
        redirectTo: 'https://education.southofrussia.ru/stamp.pdf',
        code: 302,
    },
    {
        path: '^/oplata',
        redirectTo: '/for-individuals/crediting/remote-payment-methods-for-loans',
        code: 302,
    },
    {
        path: '^/transformation',
        redirectTo: '/',
        code: 302,
    },
    {
        path: '^/ru/about/transformation',
        redirectTo: '/',
        code: 302,
    },
    {
        path: '^/cab/csi',
        redirectTo: '/cabinet/csi-service',
        code: 302,
    },
    {
        path: '^/c02',
        redirectTo: '/for-individuals/cards/rerelease-card?step-type=MainStep',
        code: 302,
    },
    {
        path: '^/ru/terminals',
        redirectTo: '/about/offices-and-atms?tab=2',
        code: 302,
    },
    {
        path: '^/ru/fiz/mir-pay-promo',
        redirectTo: '/for-individuals/cards/card-features/mir-pay',
        code: 302,
    },
    {
        path: '^/s/.{1,}',
        redirectTo: 'https://cib.app/',
        replacedPathPart: '/s/',
        code: 301,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/narod-mir',
        redirectTo: '/for-individuals/cards/debet-cards/narod-mir?form-type=new&step-type=MainStep',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/mir',
        redirectTo: '/for-individuals/cards/debet-cards/mir?form-type=new&step-type=MainStep',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/univ',
        redirectTo: '/for-individuals/cards/debet-cards/univ?form-type=new&step-type=MainStep',
        code: 302,
    },
    {
        path: '^/docs$',
        redirectTo: '/files/services/fiz/pdf/documenti_na_obekt(ipoteka).pdf',
        code: 302,
    },
    {
        path: '^/c03$',
        redirectTo: '/for-individuals/cards/debet-cards/advanced',
        code: 302,
    },
    {
        path: '^/ru/fiz/bankovskie-karty/new-products/additional-card',
        // eslint-disable-next-line max-len
        redirectTo: '/for-individuals/cards/debet-cards/advanced?form-type=FormAdditionalCard&step-type=MainStep#debet-card-bid',
        code: 302,
    },
    // teachers cards redirects start
    {
        path: '^/for-individuals/cards/teacher-card\\?univ=donstu$',
        redirectTo: 'https://dgtu.centrinvest.ru',
        code: 302,
    },
    {
        path: '^/ru/teacher-card\\?univ=rsue$',
        redirectTo: 'https://rinch.centrinvest.ru',
        code: 302,
    },
    {
        path: '^/ru/teacher-card\\?univ=iwtsedov$',
        redirectTo: 'http://ivt.centrinvest.ru',
        code: 302,
    },
    {
        path: '^/ru/teacher-card\\?univ=sfedu$',
        redirectTo: 'https://sfedu.centrinvest.ru',
        code: 302,
    },
    {
        path: '^/for-individuals/cards/teacher-card\\?univ=ranh$',
        redirectTo: 'https://ranepa.centrinvest.ru',
        code: 302,
    },
    {
        path: '^/ru/teacher-card/rgups$',
        redirectTo: 'https://rgups.centrinvest.ru',
        code: 302,
    },
    {
        path: '^/for-individuals/cards/teacher-card\\?univ=rostgmu$',
        redirectTo: 'https://rostgmu.centrinvest.ru/',
        code: 302,
    },
    {
        path: '^/ru/teacher-card.{1,}',
        redirectTo: '/for-individuals/cards/teacher-card',
        replacedPathPart: '/ru/teacher-card',
        code: 302,
    },
    // teachers cards redirects end
    // {
    //     path: '^/ru/promo/{0,1}(\\?.{0,})?$',
    //     redirectTo: '/promo',
    //     replacedPathPart: '/ru/promo',
    //     code: 302,
    // },
    {
        path: '^/hystory$',
        redirectTo: '/history',
        code: 302,
    },
    {
        path: '^/ru/dbo$',
        redirectTo: '/dbo',
        code: 302,
    },
    {
        path: '^/ru/samsung-card$',
        redirectTo: '/for-individuals/cards/card-features/samsung-pay',
        code: 302,
    },
    {
        path: '^/ru/biz/equiring$',
        redirectTo: '/business/acquiring',
        code: 302,
    },
    {
        path: '^/for-individuals/deposits/appointment',
        redirectTo: 'https://centrinvest.ru/cabinet/remote-recording/unit',
        replacedPathPart: '/for-individuals/deposits/appointment',
        code: 302,
    },
    {
        path: '^/for-individuals/crediting/kredit-za-5-minut',
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-za-5-minut',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-v-den-obrashcheniya',
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-v-den-obrashcheniya',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-s-nizkoy-protsentnoy-stavkoy',
        // eslint-disable-next-line max-len
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-s-nizkoy-protsentnoy-stavkoy',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-nalichnymi-pod-nizkiy-protsent',
        // eslint-disable-next-line max-len
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-nalichnymi-pod-nizkiy-protsent',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-s-21-goda',
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-s-21-goda',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-nalichnymi-na-remont',
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-nalichnymi-na-remont',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-nalichnymi-dlya-byudzhetnikov',
        // eslint-disable-next-line max-len
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-nalichnymi-dlya-byudzhetnikov',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-na-svadbu',
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-na-svadbu',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-na-lechenie',
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-na-lechenie',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-na-otpusk',
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-na-otpusk',
        code: 301,
    },
    {
        path: '^/for-individuals/crediting/kredit-bez-podtverzhdeniya-dohoda',
        // eslint-disable-next-line max-len
        redirectTo: 'https://www.centrinvest.ru/for-individuals/crediting/consumer-loan/kredit-bez-podtverzhdeniya-dohoda',
        code: 301,
    },
    {
        path: '^/about/investors/shareholders',
        redirectTo: '/about/investors/struct-controls',
        code: 302,
    },
    {
        path: '^/publications/ecosystem-src/shareholders.html',
        redirectTo: '/about/investors/struct-controls',
        code: 302,
    },
];
